module.exports = __webpack_public_path__ + "static/media/myfiles.d0c7e632.gif";